import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useRtl as ee } from "../../_mixins/use-rtl.js";
import oe from "./common-props.js";
import te from "./styles/index.cssr.js";
import ce from "../../_mixins/use-config.js";
import P from "../../_mixins/use-theme.js";
import { createKey as n } from "../../_utils/cssr/index.js";
import { getMargin as ne } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { useThemeClass as le } from "../../_mixins/use-css-vars-class.js";
import { color2Class as B } from "../../_utils/css/color-to-class.js";
import { resolveWrappedSlot as R } from "../../_utils/vue/resolve-slot.js";
import re from "../../_internal/close/src/Close.js";
import { createInjectionKey as se } from "../../_utils/vue/create-injection-key.js";
import { warnOnce as ae } from "../../_utils/naive/warn.js";
import ie from "../styles/light.js";
import { call as de } from "../../_utils/vue/call.js";
import { defineComponent as he, watchEffect as ge, provide as fe, computed as y, h as d } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as Ce, toRef as ue } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const me = Object.assign(Object.assign(Object.assign({}, P.props), oe), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  checked: Boolean,
  checkable: Boolean,
  strong: Boolean,
  triggerClickOnClose: Boolean,
  onClose: [Array, Function],
  onMouseenter: Function,
  onMouseleave: Function,
  "onUpdate:checked": Function,
  onUpdateChecked: Function,
  // private
  internalCloseFocusable: {
    type: Boolean,
    default: !0
  },
  internalCloseIsButtonTag: {
    type: Boolean,
    default: !0
  },
  // deprecated
  onCheckedChange: Function
}), be = se("n-tag"), Se = he({
  name: "Tag",
  props: me,
  slots: Object,
  setup(t) {
    process.env.NODE_ENV !== "production" && ge(() => {
      t.onCheckedChange !== void 0 && ae("tag", "`on-checked-change` is deprecated, please use `on-update:checked` instead");
    });
    const s = Ce(null), {
      mergedBorderedRef: o,
      mergedClsPrefixRef: h,
      inlineThemeDisabled: g,
      mergedRtlRef: p
    } = ce(t), C = P("Tag", "-tag", te, ie, t, h);
    fe(be, {
      roundRef: ue(t, "round")
    });
    function f() {
      if (!t.disabled && t.checkable) {
        const {
          checked: e,
          onCheckedChange: c,
          onUpdateChecked: i,
          "onUpdate:checked": r
        } = t;
        i && i(!e), r && r(!e), c && c(!e);
      }
    }
    function u(e) {
      if (t.triggerClickOnClose || e.stopPropagation(), !t.disabled) {
        const {
          onClose: c
        } = t;
        c && de(c, e);
      }
    }
    const m = {
      setTextContent(e) {
        const {
          value: c
        } = s;
        c && (c.textContent = e);
      }
    }, b = ee("Tag", p, h), l = y(() => {
      const {
        type: e,
        size: c,
        color: {
          color: i,
          textColor: r
        } = {}
      } = t, {
        common: {
          cubicBezierEaseInOut: k
        },
        self: {
          padding: z,
          closeMargin: _,
          borderRadius: I,
          opacityDisabled: T,
          textColorCheckable: O,
          textColorHoverCheckable: M,
          textColorPressedCheckable: j,
          textColorChecked: F,
          colorCheckable: H,
          colorHoverCheckable: S,
          colorPressedCheckable: E,
          colorChecked: N,
          colorCheckedHover: U,
          colorCheckedPressed: D,
          closeBorderRadius: V,
          fontWeightStrong: w,
          [n("colorBordered", e)]: K,
          [n("closeSize", c)]: W,
          [n("closeIconSize", c)]: A,
          [n("fontSize", c)]: L,
          [n("height", c)]: x,
          [n("color", e)]: q,
          [n("textColor", e)]: G,
          [n("border", e)]: J,
          [n("closeIconColor", e)]: $,
          [n("closeIconColorHover", e)]: Q,
          [n("closeIconColorPressed", e)]: X,
          [n("closeColorHover", e)]: Y,
          [n("closeColorPressed", e)]: Z
        }
      } = C.value, v = ne(_);
      return {
        "--n-font-weight-strong": w,
        "--n-avatar-size-override": `calc(${x} - 8px)`,
        "--n-bezier": k,
        "--n-border-radius": I,
        "--n-border": J,
        "--n-close-icon-size": A,
        "--n-close-color-pressed": Z,
        "--n-close-color-hover": Y,
        "--n-close-border-radius": V,
        "--n-close-icon-color": $,
        "--n-close-icon-color-hover": Q,
        "--n-close-icon-color-pressed": X,
        "--n-close-icon-color-disabled": $,
        "--n-close-margin-top": v.top,
        "--n-close-margin-right": v.right,
        "--n-close-margin-bottom": v.bottom,
        "--n-close-margin-left": v.left,
        "--n-close-size": W,
        "--n-color": i || (o.value ? K : q),
        "--n-color-checkable": H,
        "--n-color-checked": N,
        "--n-color-checked-hover": U,
        "--n-color-checked-pressed": D,
        "--n-color-hover-checkable": S,
        "--n-color-pressed-checkable": E,
        "--n-font-size": L,
        "--n-height": x,
        "--n-opacity-disabled": T,
        "--n-padding": z,
        "--n-text-color": r || G,
        "--n-text-color-checkable": O,
        "--n-text-color-checked": F,
        "--n-text-color-hover-checkable": M,
        "--n-text-color-pressed-checkable": j
      };
    }), a = g ? le("tag", y(() => {
      let e = "";
      const {
        type: c,
        size: i,
        color: {
          color: r,
          textColor: k
        } = {}
      } = t;
      return e += c[0], e += i[0], r && (e += `a${B(r)}`), k && (e += `b${B(k)}`), o.value && (e += "c"), e;
    }), l, t) : void 0;
    return Object.assign(Object.assign({}, m), {
      rtlEnabled: b,
      mergedClsPrefix: h,
      contentRef: s,
      mergedBordered: o,
      handleClick: f,
      handleCloseClick: u,
      cssVars: g ? void 0 : l,
      themeClass: a == null ? void 0 : a.themeClass,
      onRender: a == null ? void 0 : a.onRender
    });
  },
  render() {
    var t, s;
    const {
      mergedClsPrefix: o,
      rtlEnabled: h,
      closable: g,
      color: {
        borderColor: p
      } = {},
      round: C,
      onRender: f,
      $slots: u
    } = this;
    f == null || f();
    const m = R(u.avatar, (l) => l && d("div", {
      class: `${o}-tag__avatar`
    }, l)), b = R(u.icon, (l) => l && d("div", {
      class: `${o}-tag__icon`
    }, l));
    return d("div", {
      class: [`${o}-tag`, this.themeClass, {
        [`${o}-tag--rtl`]: h,
        [`${o}-tag--strong`]: this.strong,
        [`${o}-tag--disabled`]: this.disabled,
        [`${o}-tag--checkable`]: this.checkable,
        [`${o}-tag--checked`]: this.checkable && this.checked,
        [`${o}-tag--round`]: C,
        [`${o}-tag--avatar`]: m,
        [`${o}-tag--icon`]: b,
        [`${o}-tag--closable`]: g
      }],
      style: this.cssVars,
      onClick: this.handleClick,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave
    }, b || m, d("span", {
      class: `${o}-tag__content`,
      ref: "contentRef"
    }, (s = (t = this.$slots).default) === null || s === void 0 ? void 0 : s.call(t)), !this.checkable && g ? d(re, {
      clsPrefix: o,
      class: `${o}-tag__close`,
      disabled: this.disabled,
      onClick: this.handleCloseClick,
      focusable: this.internalCloseFocusable,
      round: C,
      isButtonTag: this.internalCloseIsButtonTag,
      absolute: !0
    }) : null, !this.checkable && this.mergedBordered ? d("div", {
      class: `${o}-tag__border`,
      style: {
        borderColor: p
      }
    }) : null);
  }
});
export {
  Se as default,
  be as tagInjectionKey,
  me as tagProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tag/src/Tag.js
// module id = 270
// module chunks = 67